package com.klantenstop.web.pages.categories

import com.klantenstop.web.data.models.domain.Category
import com.klantenstop.web.utils.MVI

interface AllCategoriesContract : MVI<AllCategoriesContract.State, AllCategoriesContract.Intent, AllCategoriesContract.Effect> {

    data class State(
        val categories: List<Category> = emptyList(),
        val loading: Boolean = true
    )

    sealed class Intent {
        data object LoadCategories : Intent()
    }

    sealed class Effect
}
